import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for P.F. Candle Co.'s "Piñon - 7.2 oz Standard
// Candle" (p_2uknhr7z), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint — verbatim
// comment, real reviewer, real rating, real publish date.
export const review_pfc4: FaireReviewEntity = {
  token: "review_pfc4",
  type: "review",
  brandName: "P.F. Candle Co.",
  brandToken: "b_a9b3b023",
  productToken: "p_2uknhr7z",
  reviewType: "product",
  reviewerName: "Paula Ventura",
  reviewerLocation: "Berkeley, CA, United States",
  stars: 5,
  reviewText:
    "The scents are amazing, there's no plastic at all in the shipping, and we are able to reuse the jars after use. It perfectly fits our store's mission. Thank you PF Candles!",
  reviewDate: "Dec 23, 2021",
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:49:30.000Z",
    importedBy: "entity-db-cli",
  },
};
